import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "50%",
      rows: {
        row1: [
          {
            name: "importSubmissionType",
            label: "Submission Type",
            component: "dropdown",
            Value: "bill",
            options: [
              { label: "Bill Of Entry", value: "bill" },
              { label: "Bill of Entry (DTA Sales)", value: "entry" },
            ],

            endIconName: "LuChevronDown",
            iconColor: "gray-400",
          },
        ],
        row2: [
          {
            name: "importSourceOfImport",
            label: "Source of Import",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            options: [{ label: "Abbroad", value: "Abbroad" }],
          },
        ],
        row3: [
          {
            name: "importDestination",
            label : "Destination",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            options: [{ label: "DTA", value: "DTA" }],
          },
        ],
        row4: [
          {
            name: "importJointFiling",
            actionText: "Joint Filing",
            component: "typographytext",
            actionTextColor: "var(--brand-1000)",
          },
        ],
        row5: [
          {
            name: "isImportJointFiling",
            component: "checkboxbox",
            sx: {
              height: 20,
              alignItems: "center",
            },
          },
          {
            name: "importJointFiling",
            component: "textarea",
            disabled: false,
            width: "100%",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],

        row6: [
          {
            name: "importPurposeOfFiling",
            label: "Purpose of Filling",
            component: "dropdown",

            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            options : [
              {label : "Manufacturing" , value : "Manufacturing"},
              {label : "Trading",value : "Trading"},
              {label : "Ware Housing",value : "Ware Housing"},
              {label : "IT/ITES",value : "IT/ITES"},
              {label : "Manufacturing Service",value : "Manufacturing Service"}
            ]
          },
        ],
        row7: [
          {
            name: "Joint Filing",
            actionText: "Provisional Assessment",
            component: "typographytext",
            actionTextColor: "var(--brand-1000)",
          },
        ],
        row8: [
          {
            name: "isImportProvisionalAssessment",
            component: "checkboxbox",

            sx: {
              height: 20,
              alignItems: "center",
            },
          },
          {
            name: "importProvisionalAssessment",
            // actionText: "Provisional Assessment",
            component: "textarea",
            disabled: false,
            width: "100%",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row9: [
          {
            name: "importDestinationGateWay",
            label: "Destination Gateway",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getPorts",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
          },
        ],
        row10: [
          {
            name: "importSBNote",
            label: "SB No",
            component: "text-field",
            width: "100%",
            disabled: true,
          },
          {
            name: "importSBDate",
            component: "dateselector",
            width: "100%",
            disabled: true,
          },
        ],
        row11: [
          {
            name: "isImportAdvanceDutyPaid",
            checkboxLabel: "Advance Duty Paid",

            component: "checkboxbox",
          },
        ],
        row12: [
          {
            name: "importNonGSTRegnReason",
            actionText: "Non GST Regn Reason",
            component: "textarea",
            disabled: false,
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
      },
    },
  ],
};
